import x43 from '../../../images/Suikoden/SonyaAnyPercentGlitchless/GlitchlessSonyax43.png';
import x44 from '../../../images/Suikoden/SonyaAnyPercentGlitchless/GlitchlessSonyax44.png';
import x45 from '../../../images/Suikoden/SonyaAnyPercentGlitchless/GlitchlessSonyax45.png';
import x46 from '../../../images/Suikoden/SonyaAnyPercentGlitchless/GlitchlessSonyax46.png';
import x47 from '../../../images/Suikoden/SonyaAnyPercentGlitchless/GlitchlessSonyax47.png';
import x48 from '../../../images/Suikoden/SonyaAnyPercentGlitchless/GlitchlessSonyax48.png';
import x49 from '../../../images/Suikoden/SonyaAnyPercentGlitchless/GlitchlessSonyax49.png';
import x4a from '../../../images/Suikoden/SonyaAnyPercentGlitchless/GlitchlessSonyax4a.png';
import x4b from '../../../images/Suikoden/SonyaAnyPercentGlitchless/GlitchlessSonyax4b.png';
import x4c from '../../../images/Suikoden/SonyaAnyPercentGlitchless/GlitchlessSonyax4c.png';
import x4d from '../../../images/Suikoden/SonyaAnyPercentGlitchless/GlitchlessSonyax4d.png';
import x4e from '../../../images/Suikoden/SonyaAnyPercentGlitchless/GlitchlessSonyax4e.png';
import x4f from '../../../images/Suikoden/SonyaAnyPercentGlitchless/GlitchlessSonyax4f.png';
import x50 from '../../../images/Suikoden/SonyaAnyPercentGlitchless/GlitchlessSonyax50.png';
import x51 from '../../../images/Suikoden/SonyaAnyPercentGlitchless/GlitchlessSonyax51.png';
import x52 from '../../../images/Suikoden/SonyaAnyPercentGlitchless/GlitchlessSonyax52.png';
import x53 from '../../../images/Suikoden/SonyaAnyPercentGlitchless/GlitchlessSonyax53.png';
import x54 from '../../../images/Suikoden/SonyaAnyPercentGlitchless/GlitchlessSonyax54.png';
import x55 from '../../../images/Suikoden/SonyaAnyPercentGlitchless/GlitchlessSonyax55.png';
import x56 from '../../../images/Suikoden/SonyaAnyPercentGlitchless/GlitchlessSonyax56.png';
import x57 from '../../../images/Suikoden/SonyaAnyPercentGlitchless/GlitchlessSonyax57.png';
import x58 from '../../../images/Suikoden/SonyaAnyPercentGlitchless/GlitchlessSonyax58.png';
import x59 from '../../../images/Suikoden/SonyaAnyPercentGlitchless/GlitchlessSonyax59.png';
import x5a from '../../../images/Suikoden/SonyaAnyPercentGlitchless/GlitchlessSonyax5a.png';
import x5b from '../../../images/Suikoden/SonyaAnyPercentGlitchless/GlitchlessSonyax5b.png';
import x5c from '../../../images/Suikoden/SonyaAnyPercentGlitchless/GlitchlessSonyax5c.png';
import x5d from '../../../images/Suikoden/SonyaAnyPercentGlitchless/GlitchlessSonyax5d.png';
import x5e from '../../../images/Suikoden/SonyaAnyPercentGlitchless/GlitchlessSonyax5e.png';
import x5f from '../../../images/Suikoden/SonyaAnyPercentGlitchless/GlitchlessSonyax5f.png';

export default [
  {
    image: x43,
    additionalInfo: [],
    seed: '0x43',
    main: {
      vertical: 'Bottom',
      horizontal: 'Middle'
    },
    secondary: {
      vertical: 'Middle',
      horizontal: 'Left'
    }
  },
  {
    image: x44,
    additionalInfo: [],
    seed: '0x44',
    main: {
      vertical: 'Middle',
      horizontal: 'Right'
    },
    secondary: {
      vertical: 'Bottom',
      horizontal: 'Right'
    }
  },
  {
    image: x45,
    additionalInfo: [],
    seed: '0x45',
    main: {
      vertical: 'Middle',
      horizontal: 'Middle'
    },
    secondary: {
      vertical: 'Top',
      horizontal: 'Middle'
    }
  },
  {
    image: x46,
    additionalInfo: [],
    seed: '0x46',
    main: {
      vertical: 'Top',
      horizontal: 'Left'
    },
    secondary: {
      vertical: 'Top',
      horizontal: 'Left'
    }
  },
  {
    image: x47,
    additionalInfo: [],
    seed: '0x47',
    main: {
      vertical: 'Bottom',
      horizontal: 'Middle'
    },
    secondary: {
      vertical: 'Top',
      horizontal: 'Right'
    }
  },
  {
    image: x48,
    additionalInfo: [],
    seed: '0x48',
    main: {
      vertical: 'Middle',
      horizontal: 'Left'
    },
    secondary: {
      vertical: 'Top',
      horizontal: 'Right'
    }
  },
  {
    image: x49,
    additionalInfo: [],
    seed: '0x49',
    main: {
      vertical: 'Top',
      horizontal: 'Middle'
    },
    secondary: {
      vertical: 'Middle',
      horizontal: 'Right'
    }
  },
  {
    image: x4a,
    additionalInfo: [],
    seed: '0x4a',
    main: {
      vertical: 'Bottom',
      horizontal: 'Left'
    },
    secondary: {
      vertical: 'Bottom',
      horizontal: 'Right'
    }
  },
  {
    image: x4b,
    additionalInfo: [],
    seed: '0x4b',
    main: {
      vertical: 'Bottom',
      horizontal: 'Right'
    },
    secondary: {
      vertical: 'Top',
      horizontal: 'Left'
    }
  },
  {
    image: x4c,
    additionalInfo: ['Hard to see'],
    seed: '0x4c',
    main: {
      vertical: 'Middle',
      horizontal: 'Left'
    },
    secondary: {
      vertical: 'Top',
      horizontal: 'Right'
    }
  },
  {
    image: x4d,
    additionalInfo: [],
    seed: '0x4d',
    main: {
      vertical: 'Top',
      horizontal: 'Right'
    },
    secondary: {
      vertical: 'Middle',
      horizontal: 'Left'
    }
  },
  {
    image: x4e,
    additionalInfo: ['Hard to see'],
    seed: '0x4e',
    main: {
      vertical: 'Bottom',
      horizontal: 'Middle'
    },
    secondary: {
      vertical: 'Middle',
      horizontal: 'Left'
    }
  },
  {
    image: x4f,
    additionalInfo: [],
    seed: '0x4f',
    main: {
      vertical: 'Middle',
      horizontal: 'Right'
    },
    secondary: {
      vertical: 'Top',
      horizontal: 'Right'
    }
  },
  {
    image: x50,
    additionalInfo: ['Hard to see'],
    seed: '0x50',
    main: {
      vertical: 'Middle',
      horizontal: 'Middle'
    },
    secondary: {
      vertical: 'Top',
      horizontal: 'Middle'
    }
  },
  {
    image: x51,
    additionalInfo: [],
    seed: '0x51',
    main: {
      vertical: 'Top',
      horizontal: 'Left'
    },
    secondary: {
      vertical: 'Middle',
      horizontal: 'Left'
    }
  },
  {
    image: x52,
    additionalInfo: ['Hard to see'],
    seed: '0x52',
    main: {
      vertical: 'Bottom',
      horizontal: 'Middle'
    },
    secondary: {
      vertical: 'Top',
      horizontal: 'Right'
    }
  },
  {
    image: x53,
    additionalInfo: [],
    seed: '0x53',
    main: {
      vertical: 'Middle',
      horizontal: 'Left'
    },
    secondary: {
      vertical: 'Bottom',
      horizontal: 'Middle'
    }
  },
  {
    image: x54,
    additionalInfo: [],
    seed: '0x54',
    main: {
      vertical: 'Top',
      horizontal: 'Middle'
    },
    secondary: {
      vertical: 'Middle',
      horizontal: 'Right'
    }
  },
  {
    image: x55,
    additionalInfo: ['Hard to see'],
    seed: '0x55',
    main: {
      vertical: 'Bottom',
      horizontal: 'Left'
    },
    secondary: {
      vertical: 'Bottom',
      horizontal: 'Middle'
    }
  },
  {
    image: x56,
    additionalInfo: ['In between 4 quantrants'],
    seed: '0x56',
    main: {
      vertical: 'Bottom',
      horizontal: 'Right'
    },
    secondary: {
      vertical: 'Top',
      horizontal: 'Left'
    }
  },
  {
    image: x57,
    additionalInfo: [],
    seed: '0x57',
    main: {
      vertical: 'Middle',
      horizontal: 'Left'
    },
    secondary: {
      vertical: 'Middle',
      horizontal: 'Right'
    }
  },
  {
    image: x58,
    additionalInfo: [],
    seed: '0x58',
    main: {
      vertical: 'Top',
      horizontal: 'Right'
    },
    secondary: {
      vertical: 'Middle',
      horizontal: 'Left'
    }
  },
  {
    image: x59,
    additionalInfo: [],
    seed: '0x59',
    main: {
      vertical: 'Bottom',
      horizontal: 'Left'
    },
    secondary: {
      vertical: 'Bottom',
      horizontal: 'Right'
    }
  },
  {
    image: x5a,
    additionalInfo: ['Hard to see'],
    seed: '0x50',
    main: {
      vertical: 'Middle',
      horizontal: 'Right'
    },
    secondary: {
      vertical: 'Bottom',
      horizontal: 'Middle'
    }
  },
  {
    image: x5b,
    additionalInfo: [],
    seed: '0x51',
    main: {
      vertical: 'Top',
      horizontal: 'Middle'
    },
    secondary: {
      vertical: 'Bottom',
      horizontal: 'Left'
    }
  },
  {
    image: x5c,
    additionalInfo: [],
    seed: '0x5c',
    main: {
      vertical: 'Top',
      horizontal: 'Right'
    },
    secondary: {
      vertical: 'Top',
      horizontal: 'Right'
    }
  },
  {
    image: x5d,
    additionalInfo: [],
    seed: '0x5d',
    main: {
      vertical: 'Bottom',
      horizontal: 'Middle'
    },
    secondary: {
      vertical: 'Top',
      horizontal: 'Middle'
    }
  },
  {
    image: x5e,
    additionalInfo: [],
    seed: '0x5e',
    main: {
      vertical: 'Middle',
      horizontal: 'Left'
    },
    secondary: {
      vertical: 'Middle',
      horizontal: 'Left'
    }
  },
  {
    image: x5f,
    additionalInfo: [],
    seed: '0x5f',
    main: {
      vertical: 'Top',
      horizontal: 'Middle'
    },
    secondary: {
      vertical: 'Bottom',
      horizontal: 'Right'
    }
  }
]
